import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';
import { getAuth } from 'firebase/auth';

export function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { user, loading, onboardingCompleted } = useAuth();
  const location = useLocation();
  const [waitingForSync, setWaitingForSync] = useState(false);

  useEffect(() => {
    if (waitingForSync) {
      const timeout = setTimeout(() => {
        setWaitingForSync(false);
      }, 3000);

      return () => clearTimeout(timeout);
    }
  }, [waitingForSync]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-brand-primary" />
      </div>
    );
  }

  if (!user && !loading) {
    const auth = getAuth();
    const firebaseUser = auth.currentUser;

    if (firebaseUser) {
      if (!waitingForSync) {
        setWaitingForSync(true);
        return (
          <div className="min-h-screen flex items-center justify-center">
            <Loader2 className="h-8 w-8 animate-spin text-brand-primary" />
          </div>
        );
      }

      if (waitingForSync) {
        return (
          <div className="min-h-screen flex items-center justify-center">
            <Loader2 className="h-8 w-8 animate-spin text-brand-primary" />
          </div>
        );
      }

      return <>{children}</>;
    }

    return <Navigate to="/login" />;
  }

  if (onboardingCompleted === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-brand-primary" />
      </div>
    );
  }
  if (onboardingCompleted === false && location.pathname !== '/onboarding') {
    return <Navigate to="/onboarding" replace />;
  }

  return <>{children}</>;
}
